import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChildren,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { IonInput } from "@ionic/angular";
import { AuthService } from "src/app/services/auth.service";
import { CursosService } from "src/app/services/cursos.service";
@Component({
  selector: "app-menu-curso",
  templateUrl: "./menu-curso.component.html",
  styleUrls: ["./menu-curso.component.scss"],
})
export class MenuCursoComponent implements OnInit {
  @Output() OpcionMenu = new EventEmitter<any>();
  @Input() menuData: any;
  @Input() menu: any;
  @Input() menuSelect: any;

  selectMenu = "present";
  selectOption = 1;

  constructor(
    private authService: AuthService,
    private cursosService: CursosService
  ) {
    this.emitData();
  }

  ngOnInit() {}

  ngOnChanges() {
    this.reconstruirFiltros();
  }

  reconstruirFiltros() {
    console.log(this.menuSelect);
    this.selectMenu = this.menuSelect?.selectMenu;
    this.selectOption = this.menuSelect?.selectOption;
  }

  selectOptionValue(option, value) {
    this.selectMenu = value;
    this.selectOption = option;
    this.emitData();
  }

  emitData() {
    this.OpcionMenu.emit({
      selectMenu: this.selectMenu,
      selectOption: this.selectOption,
    });
  }
}
